module.exports = __webpack_public_path__ + "img/b6659b0.png";